module.exports = __webpack_public_path__ + "img/Redem-Logo.90075e50.png";